import { useEffect, useState, useCallback } from 'react';
import { api } from '../lib/api';
import { streamer } from '../mock';

const FALLBACK = {
  tagline: streamer.tagline,
  description: streamer.description
};

export function useBio() {
  const [bio, setBio] = useState(FALLBACK);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    api.get('/bio').then((resp) => {
      if (cancelled) return;
      setBio({
        tagline: resp.data?.tagline || FALLBACK.tagline,
        description: resp.data?.description || FALLBACK.description
      });
      setLoaded(true);
    }).catch(() => setLoaded(true));
    return () => { cancelled = true; };
  }, []);

  const save = useCallback(async (next) => {
    const resp = await api.put('/bio', next);
    setBio({
      tagline: resp.data.tagline,
      description: resp.data.description
    });
    return resp.data;
  }, []);

  return { bio, loaded, save };
}
